let chat = (function () {
  function bindEvents() {
    const chatButtons = document.querySelectorAll(
      '.uc_block_cognigy .linkButton[title="Zum Chat"]',
    );
    if (chatButtons) {
      chatButtons.forEach(function (button) {
        button.addEventListener('click', function (e) {
          if (typeof window.webchat !== 'undefined') {
            e.preventDefault();
            window.webchat?.open();
          }
        });
      });
    }
  }

  function init() {
    bindEvents();
  }

  return {
    init: init,
  };
})();
chat.init();
